export default __webpack_public_path__ + "static/media/E306A619-3C09-4135-A14D-3E98098EEC8A.f99a5325.jpeg";